export default __webpack_public_path__ + "static/media/dst.b13c7238.png";